import { manuallyNavigate } from "../../../modules/spatialNavigation";
import ArrowButtonComponent from "./ArrowButtonComponent";
import * as styles from "./styles.module.scss";

const DPadKeyWrapper = () => {
  return (
    <div className={styles.container}>
      <ArrowButtonComponent icon="&#xe316;" className={styles.upButton} onClick={() => manuallyNavigate("up")} />
      <ArrowButtonComponent icon="&#xe313;" className={styles.downButton} onClick={() => manuallyNavigate("down")} />
      <ArrowButtonComponent icon="&#xef4a;" className={styles.enterButton} onClick={() => manuallyNavigate("enter")} />
      <ArrowButtonComponent icon="&#xe314;" className={styles.leftButton} onClick={() => manuallyNavigate("left")} />
      <ArrowButtonComponent icon="&#xe315;" className={styles.rightButton} onClick={() => manuallyNavigate("right")} />
    </div>
  );
};
export default DPadKeyWrapper;
